// Styles
import styled from 'styled-components'

// Core
import Collapse from '@material-ui/core/Collapse'
import React, {Fragment, useState} from 'react'

// Components, services, etc
import classnames from 'classnames'
import Button from 'components/Button'
import Icon from 'components/Icon'
import TextInput from 'components/TextInput'
import {
  LoanDetailConfigType,
  LOAN_DETAILS_FIELD_CONFIG,
  LOAN_DETAILS_OPTIONAL_FIELD_CONFIG
} from 'constants/loanDetailsConstants'
import {Field} from 'react-final-form'
import FormField from './FormField'
import Select from 'components/Select'

const LoanDetailsFieldWrapper = ({
  id,
  label,
  placeholder,
  fullWidth,
  ...restProps
}: LoanDetailConfigType) => {
  return (
    <Field name={id}>
      {({input, meta}) => {
        if (restProps.type === 'text') {
          return (
            <TextInput
              label={label}
              placeholder={placeholder}
              value={input.value}
              onChange={e => input.onChange(e.target.value)}
              error={meta.error && meta.touched}
              helperText={meta.touched && meta.error}
              autoFocus
              className={classnames({'full-width': fullWidth})}
            />
          )
        } else if (restProps.type === 'select') {
          return (
            <Select
              label={label}
              options={restProps.options}
              value={input.value}
              onChange={e => input.onChange(e.target.value)}
            />
          )
        }
      }}
    </Field>
  )
}

const LoanDetailFormFields = () => {
  const [isOptionalFieldsExpanded, setIsOptionalFieldsExpanded] = useState(false)

  return (
    <FormField label='Loan Details'>
      <LoanDetailFormFieldsWrapper>
        {LOAN_DETAILS_FIELD_CONFIG.map(props => (
          <LoanDetailsFieldWrapper key={props.id} {...props} />
        ))}
      </LoanDetailFormFieldsWrapper>
      <Button
        onClick={() => setIsOptionalFieldsExpanded(!isOptionalFieldsExpanded)}
        title={
          <Fragment>
            <Icon icon={`expand_${isOptionalFieldsExpanded ? 'less' : 'more'}`} />
            Optional Information
          </Fragment>
        }
        variant='tertiary'
      />
      <Collapse in={isOptionalFieldsExpanded}>
        <LoanDetailFormFieldsWrapper>
          {LOAN_DETAILS_OPTIONAL_FIELD_CONFIG.map(props => (
            <LoanDetailsFieldWrapper key={props.id} {...props} />
          ))}
        </LoanDetailFormFieldsWrapper>
      </Collapse>
    </FormField>
  )
}

const LoanDetailFormFieldsWrapper = styled.div`
  margin-top: 16px;
  gap: 16px;
  display: flex;
  flex-wrap: wrap;

  .portal-MuiFormControl-root {
    // 16px * 2 / 3 = 10.67
    flex-basis: calc(33.3% - 10.67px);

    @media (max-width: 1024px) {
      // 16px / 2 = 8
      flex-basis: calc(50% - 8px);
    }

    @media (max-width: 834px) {
      flex-basis: 100%;
    }

    &.full-width {
      flex-basis: 100%;
    }
  }
`

export default LoanDetailFormFields
